import "babel-polyfill";
import React from "react";

import ReactDOM from "react-dom/client";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { ToastProvider } from "react-toast-notifications";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import App from "layouts/App";
import Store from "./store";
import { Provider } from "react-redux";
import { reduxStore } from "reteamStore";
import { QueryClientProvider, QueryClient } from "react-query";

const hist = createBrowserHistory();
const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<Provider store={reduxStore}>
		<Router history={hist}>
			<ToastProvider
				placement="bottom-left"
				autoDismiss={true}
				autoDismissTimeout={7000}
			>
				<Store>
					<QueryClientProvider client={queryClient}>
						<App />
					</QueryClientProvider>
				</Store>
			</ToastProvider>
		</Router>
	</Provider>
);
